import React from 'react';
import { experience } from '../data.js';

export default function Experience({sectionBg}) {
  // Sort by startDate descending (most recent first)
  const sortedExperience = [...experience].sort((a, b) => {
    const aDate = a.startDate === "Present" ? new Date() : new Date(a.startDate);
    const bDate = b.startDate === "Present" ? new Date() : new Date(b.startDate);
    return bDate - aDate;
  });

  const formatDate = (date) => {
    if (!date) return "";
    if (date === "Present") return "Present";
    const options = { year: "numeric", month: "short" };
    return new Date(date).toLocaleDateString("en-US", options);
  };
  const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";
  return (
    <section id="experience" className={sectionBg + " py-16"}>
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-12 text-center">Experience</h2>

        <div className="relative">
          {/* Vertical timeline line */}
          <div className="absolute left-1/2 top-0 h-full border-l-2 border-gray-300 transform -translate-x-1/2"></div>

          <div className="space-y-16">
            {sortedExperience.map((exp, index) => {
              const isLeft = index % 2 === 0; // alternate card side in desktop

              return (
                <div key={index} className="relative flex flex-col md:flex-row md:items-start">
                  {/* Timeline circle */}
                  <div className="absolute left-1/2 transform -translate-x-1/2">
                    <div className="w-4 h-4 bg-blue-500 rounded-full border-2 border-white shadow"></div>
                  </div>

                  {/* Card */}
                  <div
                    className={cardBg + ` mt-8 md:w-5/12  rounded-lg shadow-md p-6 hover:shadow-lg transition relative
                      ${isLeft ? 'md:ml-10 md:mr-auto' : 'md:mr-10 md:ml-auto'}`}
                  >
                    {/* Date above the card aligned to its left */}
                    <div className="absolute -top-6 left-0 text-sm text-gray-600 font-medium">
                      {formatDate(exp.startDate)} – {formatDate(exp.endDate)}
                    </div>

                    <h3
                      className="text-xl font-semibold text-gray-900"
                      dangerouslySetInnerHTML={{ __html: exp.title }}
                    />
                    <p
                      className="text-gray-700 mt-1"
                      dangerouslySetInnerHTML={{ __html: exp.company }}
                    />
                    {exp.details.length > 0 && (
                      <ul className="list-disc list-inside mt-2 text-gray-700">
                        {exp.details.map((detail, i) => (
                          <li key={i} dangerouslySetInnerHTML={{ __html: detail }} />
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
